import {useState} from 'react';

type TOnlineStatus = {
  online: boolean;
  offline: boolean;
};

export const isOnline = (): boolean => navigator.onLine;

export const useOnlineStatus = (): TOnlineStatus => {
  const [online, setOnline] = useState(isOnline());

  window.addEventListener('online', () => setOnline(isOnline()));
  window.addEventListener('offline', () => setOnline(isOnline()));

  return {online, offline: !online};
};
